import type { HTMLProps } from "react";

import { css } from "@compiled/react";

import { token } from "@atlaskit/tokens";

export const LogoButton = ({
    children,
    type,
    ...rest
}: HTMLProps<HTMLButtonElement>) => {
    return (
        <button css={logoButtonCss} type="button" role="link" {...rest}>
            {children}
        </button>
    );
};

const logoButtonCss = css({
    alignItems: "center",
    backgroundColor: token("elevation.surface"),
    border: `1px solid ${token("color.border")}`,
    borderRadius: 21,
    color: token("color.text.subtle"),
    cursor: "pointer",
    display: "flex",
    fontFamily: "inherit",
    fontSize: "inherit",
    gap: "0.5rem",
    height: "40px",
    justifyContent: "center",
    padding: "0.5rem 0.75rem",
    width: "100%",
    ["&:focus, &:hover"]: {
        backgroundColor: token("elevation.surface.hovered")
    },
    ["&:focus-visible"]: {
        "outline-offset": 1
    }
});
